import styled from "styled-components";
const sectionHeaderStyle = `
font-size: 5.5rem;
font-weight: bold;
margin-bottom: 0.6rem;
width: 80%;
text-align: center;

`;

export const PageContainer = styled.div`
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.text};
  font-family: ${(props) => props.theme.font};
  position: relative;
  transition: 0.3s;
`;

export const ThemeChangerContainer = styled.div`
  z-index: 100;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.text};
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.text};
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 6rem;
`;

export const HeroContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const HeroTitle = styled.div`
  font-size: 7rem;
  font-weight: bold;
  color: ${(props) => props.theme.smrt};
  width: 70%;
  text-align: center;
`;

export const HeroSubtitle = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  letter-spacing: 0.2rem;
`;

export const HeroSubtitleBelow = styled.div`
  font-size: 1rem;
  letter-spacing: 0.2rem;
  margin-top: 3rem;
`;

export const SectionContainer = styled.div`
  margin: 20rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  position: relative;
`;
export const SectionTitle = styled.div`
  ${sectionHeaderStyle};
  color: ${(props) => props.theme.smrt};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;
export const SectionSubtitle = styled.div`
  color: ${(props) => props.theme.smrt};
  // font-weight: bold;
  letter-spacing: 0.2rem;
  font-size: 1rem;
`;

export const SectionSubHeader = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.6rem;
  width: 70%;
`;
export const SectionContent = styled.div`
  width: 70%;
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  margin: 2.5rem 0;
`;

export const SectionText = styled.div`
  width: 65%;
  font-size: 1.2rem;
  padding: 2.5rem 0;
  position: relative;
  background: ${(props) => props.theme.background};
  z-index: 2;
`;

export const TypewriterContainer = styled.div`
  font-size: 2.2rem;
  margin-top: 1rem;

  text-align: center;
`;

export const ColouredSectionText = styled.span`
  color: ${(props) => props.color};
  font-weight: bold;
`;

export const UserJourneyVideoContainer = styled.div``;

export const VerticalLine = styled.div`
  background: ${(props) => props.theme.text};
  width: 3px;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  z-index: 1;
`;

export const UserJourneyContainer = styled.div`
  margin: 3rem 0;
  padding: 2rem 0;
  background: ${(props) => props.theme.background};
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const UserJourneyTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
`;

export const UserJourneyVideo = styled.video`
  width: 80%;
  margin-top: 2rem;
  margin-bottom: 1rem;
  //border: 1px solid ${(props) => props.theme.text};
  padding: 0.01rem;
`;

export const UserJourneyVideoSubtitle = styled.div`
  font-size: 0.9rem;
  opacity: 0.65;
`;

export const IntervieweesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  margin: 4rem 0;
`;

export const IntervieweeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IntervieweePicture = styled.img`
  border-radius: 50%;
  width: 8rem;
  height: 8rem;
`;

export const IntervieweeName = styled.div`
  margin: 1rem 0;
  font-size: 1.4rem;
`;

export const IntervieweeInfo = styled.div`
  margin: 1rem 0;
  font-size: 1rem;
  text-align: center;
`;

export const UserPersonaContainer = styled.div`
  width: 70%;
  border: 1px solid;
  padding: 1rem;
`;
export const UserPersonaTopContainer = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
`;
export const UserPersonaBottomContainer = styled.div`
  display: flex;
`;

export const UserPersonaBottomSubContainer = styled.div`
  padding: 1rem;
  width: 33%;
`;
export const UserPersonaBottomContainerTitle = styled.div`
  font-weight: bold;
`;

export const JobstobedoneContainer = styled.div`
  width: 70%;
  display: flex;
  gap: 2rem;
`;

export const JobstobedoneArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const JobstobedoneSubContainer = styled.div`
  width: 33%;
  padding: 1rem;
`;
export const JobstobedoneSubContainerTitle = styled.div`
  font-size: 0.7rem;
  margin-bottom: 2rem;
`;
export const JobstobedoneHeader = styled.div`
  padding: 1rem;
  height: 20%;
  font-weight: bold;
`;
export const JobstobedoneHeaderText = styled.div``;

export const DesignCriqContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5rem 0;
  width: 100%;
`;
export const DesignCriqTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;
export const DesignCriqImage = styled.img`
  width: 60rem;
  margin: 1rem 0;
`;
export const DesignCriqTable = styled.div`
  width: 100%;
  margin: 1rem 0;
  width: 60rem;
`;
export const DesignCriqHeader = styled.div`
  padding: 2rem 1.5rem;
`;

export const DesignCriqHeaderTitle = styled.div`
  font-weight: bold;
  font-size: 1.5rem;
`;
export const DesignCriqBody = styled.div`
  display: flex;
  margin-top: 1rem;
`;
export const DesignCriqSubbody = styled.div`
  width: 50%;
`;
export const DesignCriqSubbodyTitle = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 1.5rem;
`;

export const DesignCriqList = styled.ul``;
export const DesignCriqListItem = styled.li``;

export const DesignCriq2BigContainer = styled.div`
  width: 60rem;
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.text};
  padding-bottom: 5rem;
`;
export const DesignCriq2Container = styled.div`
  width: 80%;
  margin: 1.2rem 0;
`;
export const DesignCriq2GoodHeader = styled.div`
  color: ${(props) => props.theme.green};
  font-weight: bold;
  font-size: 1.4rem;
  margin: 1rem 0;
`;

export const DesignCriq2BadHeader = styled(DesignCriq2GoodHeader)`
  color: ${(props) => props.theme.red};
`;
export const DesignCriq2Content = styled.div``;
export const ProposedSolutionContainer = styled.div`
  margin: 5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ProposedSolutionSubtitle = styled(DesignCriq2GoodHeader)`
  color: ${(props) => props.theme.text};
`;

export const ProposedSolutionText = styled.div``;

export const ProposedSolutionTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
`;

export const ProposedSolutionPicture = styled.img`
  width: 75rem;
  margin: 1rem 0;
`;

export const ProposedSolutionPicture2 = styled.img`
  width: 50rem;
  margin-bottom: 0.5rem;
`;

export const AppendixContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AppendixTitle = styled.div`
  ${sectionHeaderStyle};
`;

export const FigmaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5rem 0;
`;
export const FigmaTitle = styled.div`
  font-size: 2rem;
  margin: 1.5rem 0;
`;

export const ReferencesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5rem 0;
  width: 80%;
  gap: 1rem;
`;

export const Reference = styled.a`
  display: flex;
  jsutify-content: center;
  align-items: center;
  gap: 0.1rem;
  color: ${(props) => props.theme.text};
`;

export const SecretMessageContainer = styled.div``;

export const FooterContainer = styled.div`
  width: 100%;
  text-align: center;
  padding-bottom: 2rem;

  a {
    color: ${(props) => props.theme.text};
  }
`;
